import { render, staticRenderFns } from "./TipoTelefoneSelect.vue?vue&type=template&id=35807a8c&"
import script from "./TipoTelefoneSelect.vue?vue&type=script&lang=js&"
export * from "./TipoTelefoneSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports